import { useNavigate } from "@tanstack/react-router";
import { Button } from "@aitisal/ui/retail-storefront/button";
import { ChevronRight, Home } from "lucide-react";

interface BreadcrumbItem {
  label: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

const Breadcrumb = ({ items, className = "" }: BreadcrumbProps) => {
  const navigator = useNavigate();

  const handleNavigation = (path: string) => {
    navigator({ to: path });
  };

  return (
    <nav
      aria-label="Breadcrumb"
      className={`flex items-center space-x-2 text-sm text-gray-600 ${className}`}
    >
      <Button
        variant="link"
        onClick={() => handleNavigation("/c/retail")}
        className="flex items-center hover:text-gray-900 p-0 h-auto font-normal text-gray-600"
        aria-label="Go to home"
      >
        <Home className="w-4 h-4" />
      </Button>

      {items.map((item, index) => (
        <div key={index} className="flex items-center space-x-2">
          <ChevronRight className="w-4 h-4 text-gray-400" />
          {item.path && index < items.length - 1 ? (
            <Button
              variant="link"
              onClick={() => handleNavigation(item.path!)}
              className="hover:text-gray-900 p-0 h-auto font-normal text-gray-600"
            >
              {item.label}
            </Button>
          ) : (
            <span className="text-gray-900 font-medium" aria-current="page">
              {item.label}
            </span>
          )}
        </div>
      ))}
    </nav>
  );
};

export default Breadcrumb;
